<div class="row">
    <div class="col-sm-12">
        <app-srs-table-widget *ngIf="srsTableWidgetConfig != null && showAttrTable" [config]="srsTableWidgetConfig">
        </app-srs-table-widget>
    </div>
</div>